import React from "react";
import { motion } from "framer-motion";

const rightCloudVariants = {
  selected: {
    x: -130,
    transition: {
      duration: 3,
      delay: 2,
    },
  },
};

const leftCloudVariants = {
  selected: {
    x: 88,
    transition: {
      duration: 3,
      delay: 2,
    },
  },
};

const bushVariants = {
  selected: {
    scale: [1, 1, 1.03, 1, 1.03, 1],
    transition: {
      times: [0, 0.3, 0.4, 0.7, 0.8, 1],
      duration: 3,
      delay: 2,
    },
  },
};

const AdventureIcon = React.forwardRef((props, ref) => (
  <motion.svg
    id="Capa_1"
    enableBackground="new 0 0 512 512"
    height="512"
    viewBox="0 0 512 512"
    width="512"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    style={props.style}
  >
    <g>
      <g>
        <path
          d="m118.308 287.993-79.606 169.136c-9.701 20.611 5.337 44.309 28.117 44.309h336.097l-100.46-213.444-92.51-44.891z"
          fill="#c38959"
        />
        <path
          d="m192.648 191.963-10.293 57.797-44.806 251.677h-70.725c-22.78 0-37.818-23.698-28.117-44.309l79.605-169.133 51.541-73.887c5.061-10.752 13.325-18.137 22.795-22.145z"
          fill="#b17a4a"
        />
        <path
          d="m302.452 287.991c-1.492.985-2.879 2.124-4.142 3.386-4.84 4.831-7.825 11.508-7.825 18.883 0 14.751-11.948 26.698-26.698 26.698-7.375 0-14.052-2.985-18.883-7.815-4.831-4.831-7.815-11.508-7.815-18.883 0-14.75-11.957-26.698-26.708-26.698-7.366 0-14.043 2.985-18.873 7.815-4.831 4.831-7.825 11.508-7.825 18.883 0 14.751-11.957 26.698-26.698 26.698-7.375 0-14.052-2.985-18.883-7.815-4.831-4.831-7.815-11.508-7.815-18.883 0-9.308-4.754-17.496-11.976-22.269l51.541-109.51c16.147-34.294 64.923-34.294 81.061 0z"
          fill="#9bd069"
        />
        <path
          d="m169.853 178.485-51.541 109.51c7.222 4.773 11.976 12.962 11.976 22.269 0 7.375 2.985 14.052 7.815 18.883 4.831 4.831 11.508 7.815 18.883 7.815 3.615 0 7.062-.722 10.207-2.025l27.856-156.452c3.053-17.108 9.171-25.676 15.288-25.718-16.213.017-32.418 8.589-40.484 25.718z"
          fill="#6ec17d"
        />
      </g>
      <g>
        <path
          d="m242.544 310.028-90.09 191.41h282.271c29.326 0 48.686-30.509 36.197-57.043l-63.241-134.366-82.96-40.256z"
          fill="#c38959"
        />
        <path
          d="m309.21 223.912-9.23 51.83-40.181 225.696h-107.34l90.089-191.408 46.22-66.259c4.538-9.642 11.95-16.265 20.442-19.859z"
          fill="#b17a4a"
        />
        <path
          d="m407.679 310.026c-1.338.883-2.582 1.904-3.714 3.037-4.34 4.332-7.017 10.32-7.017 16.934 0 13.228-10.714 23.942-23.942 23.942-6.614 0-12.602-2.677-16.934-7.009s-7.009-10.32-7.009-16.934c0-13.228-10.723-23.942-23.951-23.942-6.605 0-12.593 2.676-16.925 7.008s-7.017 10.32-7.017 16.934c0 13.228-10.723 23.942-23.942 23.942-6.614 0-12.602-2.677-16.934-7.009s-7.008-10.32-7.008-16.934c0-8.347-4.263-15.69-10.74-19.97l46.22-98.205c14.48-30.753 58.221-30.753 72.693 0z"
          fill="#9bd069"
        />
        <path
          d="m288.768 211.825-46.22 98.205c6.477 4.281 10.74 11.624 10.74 19.97 0 6.614 2.677 12.602 7.008 16.934 4.332 4.332 10.32 7.009 16.934 7.009 3.242 0 6.333-.648 9.153-1.816l24.98-140.301c2.738-15.342 8.225-23.025 13.709-23.063-14.538.014-29.071 7.701-36.304 23.062z"
          fill="#6ec17d"
        />
      </g>
      <motion.g variants={bushVariants}>
        <path
          d="m141.911 409.488v-6.396c0-27.362-22.181-49.543-49.543-49.543-27.362 0-49.543 22.181-49.543 49.543v6.396c-23.925 1.651-42.825 21.568-42.825 45.913 0 25.425 20.611 46.037 46.037 46.037h92.662c25.425 0 46.037-20.611 46.037-46.037 0-24.345-18.9-44.262-42.825-45.913z"
          fill="#9bd069"
        />
        <path
          d="m37.095 455.401c0 12.713 5.153 24.228 13.487 32.551 8.324 8.334 19.839 13.487 32.551 13.487h-37.094c-12.713 0-24.228-5.153-32.551-13.487-8.335-8.324-13.488-19.839-13.488-32.551 0-24.341 18.899-44.262 42.827-45.915v-6.392c0-13.684 5.546-26.066 14.51-35.03s21.357-14.51 35.04-14.51c6.558 0 12.826 1.27 18.548 3.594-6.227 2.509-11.825 6.248-16.493 10.916-8.964 8.964-14.51 21.346-14.51 35.03v6.392c-23.928 1.652-42.827 21.573-42.827 45.915z"
          fill="#6ec17d"
        />
      </motion.g>
      <motion.g variants={bushVariants}>
        <path
          d="m365.157 441.978v-4.136c0-17.694-14.344-32.038-32.038-32.038-17.694 0-32.038 14.344-32.038 32.038v4.136c-15.471 1.068-27.693 13.947-27.693 29.69 0 16.442 13.328 29.77 29.77 29.77h59.921c16.441 0 29.77-13.328 29.77-29.77.001-15.742-12.221-28.622-27.692-29.69z"
          fill="#9bd069"
        />
        <path
          d="m297.377 471.668c0 8.221 3.332 15.667 8.722 21.05 5.383 5.389 12.829 8.722 21.05 8.722h-23.989c-8.221 0-15.667-3.332-21.05-8.722-5.389-5.383-8.722-12.829-8.722-21.05 0-15.74 12.221-28.622 27.694-29.691v-4.134c0-8.849 3.586-16.856 9.383-22.652 5.797-5.797 13.81-9.383 22.659-9.383 4.241 0 8.294.821 11.994 2.324-4.027 1.623-7.647 4.04-10.665 7.059-5.797 5.797-9.383 13.804-9.383 22.652v4.134c-15.472 1.069-27.693 13.951-27.693 29.691z"
          fill="#6ec17d"
        />
      </motion.g>
      <motion.g variants={bushVariants}>
        <path
          d="m473.405 418.568v-5.764c0-24.66-19.991-44.651-44.651-44.651-24.66 0-44.651 19.991-44.651 44.651v5.764c-21.562 1.488-38.595 19.438-38.595 41.379 0 22.915 18.576 41.49 41.49 41.49h83.512c22.915 0 41.49-18.576 41.49-41.49 0-21.94-17.033-39.891-38.595-41.379z"
          fill="#9bd069"
        />
        <path
          d="m378.94 459.947c0 11.457 4.644 21.835 12.155 29.337 7.502 7.511 17.879 12.155 29.337 12.155h-33.432c-11.457 0-21.835-4.644-29.337-12.155-7.511-7.502-12.155-17.879-12.155-29.337 0-21.937 17.032-39.891 38.598-41.38v-5.761c0-12.332 4.998-23.492 13.077-31.571s19.248-13.077 31.58-13.077c5.91 0 11.56 1.145 16.716 3.239-5.612 2.262-10.657 5.631-14.864 9.838-8.079 8.079-13.077 19.238-13.077 31.571v5.761c-21.566 1.489-38.598 19.443-38.598 41.38z"
          fill="#6ec17d"
        />
      </motion.g>
      <motion.path
        d="m478.362 101.248h-33.533c1.679-3.42 2.625-7.265 2.625-11.333 0-14.225-11.532-25.757-25.757-25.757h-76.24c-14.225 0-25.757 11.532-25.757 25.757 0 14.225 11.532 25.756 25.757 25.756h33.533c-1.679 3.42-2.625 7.266-2.625 11.333 0 14.225 11.532 25.757 25.757 25.757h76.24c14.225 0 25.757-11.532 25.757-25.757-.001-14.224-11.532-25.756-25.757-25.756z"
        fill="#f6f9f9"
        variants={rightCloudVariants}
      />
      <motion.path
        d="m344.424 89.916c0 7.105 2.881 13.549 7.549 18.207 4.658 4.668 11.102 7.549 18.207 7.549h-24.723c-7.105 0-13.549-2.881-18.207-7.549-4.668-4.657-7.549-11.102-7.549-18.207 0-14.231 11.535-25.756 25.756-25.756h24.723c-14.221 0-25.756 11.525-25.756 25.756z"
        fill="#dddaec"
        variants={rightCloudVariants}
      />
      <motion.path
        d="m426.845 152.757h-24.723c-7.116 0-13.549-2.881-18.207-7.539-4.668-4.658-7.549-11.102-7.549-18.217 0-4.069.95-7.911 2.623-11.329h24.724c-1.673 3.418-2.623 7.26-2.623 11.329 0 7.116 2.881 13.56 7.549 18.217 4.657 4.657 11.091 7.539 18.206 7.539z"
        fill="#dddaec"
        variants={rightCloudVariants}
      />
      <motion.path
        d="m43.922 38.468h33.533c-1.679-3.42-2.625-7.265-2.625-11.333 0-14.225 11.532-25.757 25.756-25.757h60.748c14.225 0 25.757 11.532 25.757 25.757 0 14.225-11.532 25.756-25.757 25.756h-18.041c1.679 3.42 2.625 7.266 2.625 11.333 0 14.225-11.532 25.757-25.757 25.757h-76.24c-14.225 0-25.757-11.532-25.757-25.757.002-14.224 11.533-25.756 25.758-25.756z"
        fill="#f6f9f9"
        variants={leftCloudVariants}
      />
      <motion.g fill="#dddaec" variants={leftCloudVariants}>
        <path d="m41.447 64.225c0-14.225 11.532-25.757 25.757-25.757h-23.282c-14.225 0-25.757 11.532-25.757 25.757s11.532 25.757 25.757 25.757h23.281c-14.225-.001-25.756-11.532-25.756-25.757z" />
        <path d="m100.737 38.468c-1.679-3.42-2.625-7.265-2.625-11.333 0-14.225 11.532-25.757 25.756-25.757h-23.281c-14.225 0-25.756 11.532-25.756 25.757 0 4.067.946 7.913 2.625 11.333z" />
      </motion.g>
      <path
        d="m490.094 510.621h-468.188c-4.278 0-7.745-3.468-7.745-7.745s3.467-7.745 7.745-7.745h468.187c4.278 0 7.745 3.468 7.745 7.745s-3.466 7.745-7.744 7.745z"
        fill="#6ec17d"
      />
    </g>
  </motion.svg>
));

export default AdventureIcon;
